import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from 'react';
export function UploadDropZone({ onFiles, disabled, children }) {
    const [over, setOver] = useState(false);
    const counter = useRef(0);
    function handleDragEnter(e) {
        if (disabled)
            return;
        e.preventDefault();
        counter.current += 1;
        if (e.dataTransfer.types.includes('Files'))
            setOver(true);
    }
    function handleDragLeave(e) {
        e.preventDefault();
        counter.current -= 1;
        if (counter.current <= 0) {
            counter.current = 0;
            setOver(false);
        }
    }
    function handleDragOver(e) {
        if (disabled)
            return;
        e.preventDefault();
        e.dataTransfer.dropEffect = 'copy';
    }
    function handleDrop(e) {
        if (disabled)
            return;
        e.preventDefault();
        counter.current = 0;
        setOver(false);
        const files = Array.from(e.dataTransfer.files ?? []);
        if (files.length > 0)
            onFiles(files);
    }
    return (_jsxs("div", { onDragEnter: handleDragEnter, onDragLeave: handleDragLeave, onDragOver: handleDragOver, onDrop: handleDrop, className: "relative", children: [children, over && (_jsx("div", { className: "pointer-events-none absolute inset-0 z-30 flex items-center justify-center rounded-2xl border-2 border-dashed backdrop-blur-sm", style: {
                    background: 'color-mix(in srgb, var(--accent) 15%, transparent)',
                    borderColor: 'var(--accent)',
                }, children: _jsxs("div", { className: "text-center", children: [_jsx("p", { className: "text-base font-semibold", style: { color: 'var(--accent)' }, children: "Suelta los archivos aqu\u00ED" }), _jsx("p", { className: "mt-1 text-xs", style: { color: 'var(--fg-2)' }, children: "PDF \u00B7 hasta 50 MB cada uno" })] }) }))] }));
}
//# sourceMappingURL=UploadDropZone.js.map